import { Link } from "react-router-dom";
import { Facebook, Linkedin } from "lucide-react";
import Logo from "./Logo";

const MENU = [
    { label: "Home", path: "/" },
    { label: "Servizi", path: "/servizi" },
    { label: "Bandi & Finanza agevolata", path: "/bandi-finanza-agevolata" },
    { label: "Full Remote", path: "/full-remote" },
    { label: "Chi siamo", path: "/chi-siamo" },
    { label: "Contatti", path: "/contatti" },
];

const SERVICES = [
    { label: "Elaborazione dati contabili", path: "/servizi" },
    { label: "Attività amministrativa e di supporto", path: "/servizi" },
    { label: "Consulenza imprenditoriale e gestionale", path: "/servizi" },
    { label: "Bandi e finanza agevolata", path: "/bandi-finanza-agevolata" },
];

const CONTACT_ROWS = [
    { k: "SEDE", v: "Isernia, Italia" },
    { k: "INDIRIZZO", v: "Corso Garibaldi 92, 86170 Isernia (IS)" },
    { k: "TELEFONO", v: <a href="tel:+393347562887" data-testid="footer-tel-cell" className="text-white/60 hover:text-white transition-colors">+39 334 756 2887</a> },
    { k: "TEL. FISSO", v: <a href="tel:+390865220588" data-testid="footer-tel-fisso" className="text-white/60 hover:text-white transition-colors">0865 220 588</a> },
    { k: "EMAIL", stack: true, v: <a href="mailto:service.business.srls@gmail.com" data-testid="footer-email" className="text-white/60 hover:text-white transition-colors">service.business.srls@gmail.com</a> },
    { k: "PEC", stack: true, v: <a href="mailto:service.business.srls@pec.it" data-testid="footer-pec" className="text-white/60 hover:text-white transition-colors">service.business.srls@pec.it</a> },
    { k: "P.IVA", v: "00999760945" },
];

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-[#070A10] border-t border-white/10 relative overflow-hidden">
            <div
                className="absolute inset-x-0 top-0 h-px"
                style={{ background: "linear-gradient(90deg, rgba(65,198,241,0.6), rgba(10,95,194,0.6), rgba(65,198,241,0.6))" }}
            />
            <div className="wrap py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-[1.3fr_0.8fr_1fr_1fr]">
                <div>
                    <Logo />
                    <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-xs">
                        L'esperienza di 30 anni al servizio delle imprese di oggi.
                    </p>
                    <p className="font-mono text-[10px] tracking-[0.28em] text-white/35 mt-6 uppercase">
                        Isernia — Molise — Italia
                    </p>
                </div>

                <nav aria-label="Menu footer">
                    <p className="font-mono text-[10px] tracking-[0.28em] text-sky-400 uppercase mb-5">Menu</p>
                    <ul className="space-y-3">
                        {MENU.map((m) => (
                            <li key={m.path + m.label}>
                                <Link to={m.path} data-testid={`footer-link-${m.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-white/60 hover:text-white transition-colors">
                                    {m.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div>
                    <p className="font-mono text-[10px] tracking-[0.28em] text-sky-400 uppercase mb-5">Servizi</p>
                    <ul className="space-y-3">
                        {SERVICES.map((s) => (
                            <li key={s.label}>
                                <Link to={s.path} data-testid={`footer-service-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-white/60 hover:text-white transition-colors">
                                    {s.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="font-mono text-[10px] tracking-[0.28em] text-sky-400 uppercase mb-5">Contatti</p>
                    <ul className="space-y-3">
                        {CONTACT_ROWS.map((r) => (
                            <li key={r.k} className={r.stack ? "flex flex-col gap-1 text-sm" : "flex items-baseline gap-3 text-sm"}>
                                <span className={"font-mono text-[9px] tracking-[0.2em] text-white/35 shrink-0 " + (r.stack ? "" : "w-[72px]")}>{r.k}</span>
                                <span className="text-white/60">{r.v}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/8">
                <div className="wrap py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-white/40">
                        © {year} Service &amp; Business SRLS. Tutti i diritti riservati.
                    </p>
                    <div className="flex items-center gap-6">
                        <Link to="/privacy-policy" data-testid="footer-link-privacy" className="text-xs text-white/40 hover:text-white transition-colors">
                            Privacy Policy
                        </Link>
                        <Link to="/cookie-policy" data-testid="footer-link-cookie" className="text-xs text-white/40 hover:text-white transition-colors">
                            Cookie Policy
                        </Link>
                        <a href="https://www.facebook.com/profile.php?id=61594996174787" target="_blank" rel="noopener noreferrer" data-testid="footer-link-facebook" aria-label="Facebook di Service & Business SRLS" className="text-white/40 hover:text-white transition-colors">
                            <Facebook className="h-4 w-4" />
                        </a>
                        <a href="https://www.linkedin.com/company/146700929/" target="_blank" rel="noopener noreferrer" data-testid="footer-link-linkedin" aria-label="LinkedIn di Service & Business SRLS" className="text-white/40 hover:text-white transition-colors">
                            <Linkedin className="h-4 w-4" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
